import React from 'react'
import {AsideDefault} from './components/aside/AsideDefault'
import {Footer} from './components/Footer'
import {HeaderWrapper} from './components/header/HeaderWrapper'
import {Toolbar} from './components/Toolbar'
import {Content} from './components/Content'
import {MasterInit} from './MasterInit'
import {PageDataProvider} from './core'
import {Outlet} from 'react-router-dom'
import {useCorrespondenceNotifier} from '../../app/features/correspondence/hooks/useCorrespondenceNotifier'
import {useCorrespondenceRealtime} from '../../app/features/correspondence/realtime/useCorrespondenceRealtime'
import {CorrespondenceChatProvider} from '../../app/features/correspondence/context/CorrespondenceChatContext'
import {CorrespondenceChatFab} from '../../app/features/correspondence/components/CorrespondenceBell'

const MasterLayout: React.FC = () => {
  useCorrespondenceRealtime()
  useCorrespondenceNotifier()
  return (
    <CorrespondenceChatProvider>
      <PageDataProvider>
        <div className='page d-flex flex-row flex-column-fluid'>
          <AsideDefault />
          <div
            className='wrapper d-flex flex-column flex-row-fluid'
            id='kt_wrapper'
            style={{backgroundColor: '#012836'}}
          >
            <HeaderWrapper />
            <div
              id='kt_content'
              className='content d-flex flex-column flex-column-fluid pt-4'
              style={{
                backgroundColor: '#012836',
              }}
            >
              <div className='post d-flex flex-column-fluid' id='kt_post'>
                <Content>
                  <Outlet />
                </Content>
              </div>
            </div>
            <Footer />
          </div>
        </div>
        <CorrespondenceChatFab />
        <MasterInit />
      </PageDataProvider>
    </CorrespondenceChatProvider>
  )
}

export {MasterLayout}
